import React from 'react';
import HeadingSection from 'components/LandingPageHeadingSection/HeadingSection';
import Styles from "../styles.js"
const TwoBedroomsOneRow = props => {
  const data = props;

  return (
    <>
    <div>
      {' '}
      <div>
        <div className="">
          <div className="container-fluid  text-white pb-4" style={{ backgroundColor: 'rgb(22, 22, 22)' }}>
            <div className="lg:container mx-auto px-xxl-5  pt-4 mt-1">
              <HeadingSection title={data.title} heading={data.heading} bgcolor={data.bgcolor} subHd={data.subHd} />
              <div className="row px-lg-0  px-xl-0 px-xxl-0  pt-md-5 pt-4  gx-5 justify-content-around">
                <div className="col-lg-4 col-md-6 px-mobile-explore ">
                  <div className="card bg-transparent border-0 ">
                    {data.href1 ? (
                      <a href={data.href1} target="_blank" rel="noreferrer">
                        <img
                          loading="lazy"
                          src={data.img}
                          className=" img img-fluid rounded-0 card-img-top px-mobile-explore-img"
                          alt="..."
                        />
                      </a>
                    ) : (
                      <div>
                        <img
                          loading="lazy"
                          src={data.img}
                          className=" img img-fluid rounded-0 card-img-top px-mobile-explore-img"
                          alt="..."
                        />
                      </div>
                    )}
                    <div className="card-body p-0 pb-4">
                      {data.href1 ? (
                        <a href={data.href1} target="_blank" rel="noreferrer">
                          <div
                            className="card-title d-flex flex-lg-row flex-column
                           justify-content-between mt-4 mb-0 mb-md-3 pb-0 pb-md-3 pt-2"
                            style={{ fontFamily: 'josefin Sans', color: '#F7F7F7' }}>
                            <div>
                              <h5 className="fs-res-24">{data.titleOne}</h5>
                            </div>

                            <div className="d-flex flex-md-column flex-row">
                              {/* <h5 className="fs-res-18 text-lg-end">Start at</h5>
                              <h5 className="fs-res-18 ps-1 ps-md-0">{data.price}</h5> */}
                              {data.soldOutOne == true ? (
                                <h5 className="fs-res-18 ps-1 ps-md-0 pt-2">{data.price}</h5>
                              ) : (
                                <>
                                  <h5 className="fs-res-18 text-lg-end">Start at</h5>
                                  <h5 className="fs-res-18 ps-1 ps-md-0">{data.price}</h5>
                                </>
                              )}
                            </div>
                          </div>
                        </a>
                      ) : (
                        <div
                          className="card-title d-flex flex-lg-row flex-column
                           justify-content-between mt-4 mb-0 mb-md-3 pb-0 pb-md-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#F7F7F7' }}>
                          <div>
                            <h5 className="fs-res-24">{data.titleOne}</h5>
                          </div>

                          <div className="d-flex flex-md-column flex-row">
                            {/* <h5 className="fs-res-18 text-lg-end">Start at</h5>
                              <h5 className="fs-res-18 ps-1 ps-md-0">{data.price}</h5> */}
                            {data.soldOutOne == true ? (
                              <h5 className="fs-res-18 ps-1 ps-md-0 pt-2">{data.price}</h5>
                            ) : (
                              <>
                                <h5 className="fs-res-18 text-lg-end">Start at</h5>
                                <h5 className="fs-res-18 ps-1 ps-md-0">{data.price}</h5>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                      <p
                        className="card-text  fs-res-24-18 pb-md-4"
                        style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
                        <p className="my-1">{data.p1}</p>
                        <p className="my-1">{data.p2}</p>
                        <p className="my-1">{data.p3}</p>
                        <p className="my-1">{data.p4}</p>
                        <p className="my-1">{data.p5}</p>
                        {data.p6 && <p className="my-1">{data.p6}</p>}
                        {data.p7 && <p className="my-1">{data.p7}</p>}
                        {data.p8 && <p className="my-1">{data.p8}</p>}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 px-mobile-explore">
                  <div className="card bg-transparent border-0   ">
                    {data.href2 ? (
                      <a href={data.href2} target="_blank" rel="noreferrer">
                        <img
                          loading="lazy"
                          src={data.imgTwo}
                          className=" img img-fluid rounded-0 card-img-top px-mobile-explore-img"
                          alt="..."
                          style={{ cursor: 'pointer' }}
                        />
                      </a>
                    ) : (
                      <div>
                        <img
                          loading="lazy"
                          src={data.imgTwo}
                          className=" img img-fluid rounded-0 card-img-top px-mobile-explore-img"
                          alt="..."
                        />
                      </div>
                    )}

                    <div className="card-body p-0 pb-4">
                      {data.href2 ? (
                        <a href={data.href2} target="_blank" rel="noreferrer">
                          <div
                            className="card-title d-flex flex-lg-row flex-column
                        justify-content-between mt-4 mb-0 mb-md-3 pb-0 pb-md-3 pt-2"
                            style={{ fontFamily: 'josefin Sans', color: '#F7F7F7', cursor: 'pointer' }}>
                            <div>
                              <h5 className="fs-res-24">{data.titleTwo}</h5>
                            </div>

                            <div className="d-flex flex-md-column flex-row">
                              {data.soldOutTwo == true ? (
                                <h5 className="fs-res-18 ps-1 pt-2 ps-md-0">{data.enSuitPrice}</h5>
                              ) : (
                                <>
                                  <h5 className="fs-res-18 text-lg-end">Start at</h5>
                                  <h5 className="fs-res-18 ps-1 ps-md-0">{data.enSuitPrice}</h5>
                                </>
                              )}
                            </div>
                          </div>
                        </a>
                      ) : (
                        <div
                          className="card-title d-flex flex-lg-row flex-column
                           justify-content-between mt-4 mb-0 mb-md-3 pb-0 pb-md-3 pt-2"
                          style={{ fontFamily: 'josefin Sans', color: '#F7F7F7' }}>
                          <div>
                            <h5 className="fs-res-24">{data.titleTwo}</h5>
                          </div>

                          <div className="d-flex flex-md-column flex-row">
                            {data.soldOutTwo == true ? (
                              <h5 className="fs-res-18 ps-1 pt-2 ps-md-0">{data.enSuitPrice}</h5>
                            ) : (
                              <>
                                <h5 className="fs-res-18 text-lg-end">Start at</h5>
                                <h5 className="fs-res-18 ps-1 ps-md-0">{data.enSuitPrice}</h5>
                              </>
                            )}
                          </div>
                        </div>
                      )}

                      <p
                        className="card-text fs-res-24-18 pb-md-4"
                        style={{ fontFamily: 'josefin Sans', color: '#a4a4a4' }}>
                        <p className="my-1">{data.enSuitP1}</p>
                        <p className="my-1">{data.enSuitP2}</p>
                        <p className="my-1">{data.enSuitP3}</p>
                        <p className="my-1">{data.enSuitP4}</p>
                        <p className="my-1">{data.enSuitP5}</p>
                        {data.enSuitP6 && <p className="my-1">{data.enSuitP6}</p>}
                        {data.enSuitP7 && <p className="my-1">{data.enSuitP7}</p>}
                        {data.enSuitP8 && <p className="my-1">{data.enSuitP8}</p>}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Styles />
    </>
    
  );
};

export default TwoBedroomsOneRow;
